export default "__VITE_ASSET__ZPUhAPdW__"